<template>
  <div class="flex min-h-72">
    <BaseCard class="flex flex-col w-full">
      <template v-if="channel.project.cover">
        <div class="w-full aspect-ratio-16/9 relative">
          <img
            :src="channel.project.cover"
            class="absolute w-full h-full inset-0 object-cover rounded-t-lg"
          />
        </div>
      </template>
      <template v-else>
        <div class="aspect-ratio-16/9 w-full bg-gray-200" />
      </template>

      <BaseCardBody>
        <ChannableFacebookCampaign
          v-if="channel.channableType === 'facebook_campaign'"
          :facebook-campaign="channel.channableData"
        />
        <ChannableGoogleAdsCampaign v-if="channel.gaCampaign" :ga-campaign="channel.gaCampaign" />
      </BaseCardBody>

      <BaseCardBody v-if="channel.page" class="flex-1">
        <span class="font-medium text-sm text-gray-600 capitalize"> σελιδα </span>
        <Page :page="channel.page" />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import mediableMixin from '@/mixins/mediableMixin';
import ChannableFacebookCampaign from './channelCard/ChannableFacebookCampaign.vue';
import ChannableGoogleAdsCampaign from './channelCard/ChannableGoogleAdsCampaign.vue';
import Page from './channelCard/Page.vue';

export default {
  mixins: [mediableMixin],

  components: {
    ChannableFacebookCampaign,
    ChannableGoogleAdsCampaign,
    Page,
  },
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
};
</script>
